export const PROMO_TYPES = {
  lease_special: { label: "Lease Special", cls: "border-indigo-300 bg-indigo-600 text-white" },
  special_apr: { label: "Special APR", cls: "border-emerald-300 bg-emerald-600 text-white" },
  special_buy: { label: "Special Buy", cls: "border-rose-300 bg-rose-600 text-white" },
  special_interest: { label: "Special Interest", cls: "border-amber-300 bg-amber-500 text-white" },
  cash_rebate: { label: "Cash Rebate", cls: "border-purple-300 bg-purple-600 text-white" },
};

export const promoBadge = (p) => (p && (p.badge_label || PROMO_TYPES[p.promo_type]?.label)) || "Special";

export function daysLeft(p) {
  if (!p || !p.end_date) return null;
  const end = new Date(p.end_date + "T23:59:59");
  if (isNaN(end.getTime())) return null;
  return Math.ceil((end - new Date()) / 86400000);
}

export function expiryLabel(p, within = 3) {
  const d = daysLeft(p);
  if (d == null || d < 0 || d > within) return null;
  return d === 0 ? "Ends today" : d === 1 ? "Ends tomorrow" : `Ends in ${d} days`;
}

export function countdownLabel(p, within = 3) {
  if (!p || !p.end_date) return null;
  const end = new Date(p.end_date + "T23:59:59");
  if (isNaN(end.getTime())) return null;
  const ms = end - new Date();
  if (ms < 0 || ms > within * 86400000) return null;
  const d = Math.floor(ms / 86400000);
  const h = Math.floor((ms % 86400000) / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  if (d >= 1) return `Ends in ${d}d ${h}h ${m}m`;
  if (h >= 1) return `Ends in ${h}h ${m}m ${s}s`;
  return `Ends in ${m}m ${s}s`;
}

// Reliable brand logos for common makes (brand-colored SVG). Broken/missing → monogram fallback (see BrandMark).
export const MAKE_LOGOS = {
  toyota: "https://cdn.simpleicons.org/toyota",
  honda: "https://cdn.simpleicons.org/honda",
  kia: "https://cdn.simpleicons.org/kia",
  ford: "https://cdn.simpleicons.org/ford",
  bmw: "https://cdn.simpleicons.org/bmw",
  audi: "https://cdn.simpleicons.org/audi",
  hyundai: "https://cdn.simpleicons.org/hyundai",
  nissan: "https://cdn.simpleicons.org/nissan",
  mazda: "https://cdn.simpleicons.org/mazda",
  subaru: "https://cdn.simpleicons.org/subaru",
  volkswagen: "https://cdn.simpleicons.org/volkswagen",
  volvo: "https://cdn.simpleicons.org/volvo",
  tesla: "https://cdn.simpleicons.org/tesla",
  porsche: "https://cdn.simpleicons.org/porsche",
  jeep: "https://cdn.simpleicons.org/jeep",
  lexus: "https://cdn.simpleicons.org/lexus",
  chevrolet: "https://cdn.simpleicons.org/chevrolet",
};

const MONO = ["bg-slate-800", "bg-rose-700", "bg-indigo-700", "bg-emerald-700", "bg-amber-600", "bg-purple-700", "bg-cyan-700"];
export function monogramColor(make) {
  const s = make || ""; let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return MONO[h % MONO.length];
}

const money = (n) => `$${Number(n).toLocaleString()}`;
export function headlineFigure(p) {
  if (!p) return null;
  if (p.apr != null) return `${p.apr}% APR`;
  if (p.monthly_payment != null) return `${money(p.monthly_payment)}/mo`;
  if (p.cash_amount != null) return `${money(p.cash_amount)} cash`;
  return null;
}
export function termLine(p) {
  if (!p) return "";
  const b = [];
  if (p.term_months != null) b.push(`${p.term_months} mo`);
  if (p.down_payment != null) b.push(`${money(p.down_payment)} down`);
  return b.join(" · ");
}
export function scopeLabel(p) {
  if (!p) return "";
  if (p.scope === "manufacturer" && p.make) return p.model ? `${p.make} ${p.model}` : `All ${p.make}`;
  if (p.scope === "vehicle") return `${(p.vehicle_ids || []).length} selected vehicle${(p.vehicle_ids || []).length !== 1 ? "s" : ""}`;
  if (p.scope === "dealer") return "Dealer offer";
  return "";
}

export function promoMatchesVehicle(p, v) {
  if (!p || !v) return false;
  if (p.scope === "vehicle") return (p.vehicle_ids || []).includes(v.id);
  if (p.scope === "manufacturer") {
    if (!p.make || (v.make || "").toLowerCase() !== String(p.make).toLowerCase()) return false;
    if (p.model && (v.model || "").toLowerCase() !== String(p.model).toLowerCase()) return false;
    return true;
  }
  if (p.scope === "dealer") return !!p.partner_id && v.partner_id === p.partner_id;
  return false;
}

// promos are pre-sorted by priority (backend); first match wins.
export function promoForVehicle(promos, v) {
  if (!promos || !promos.length || !v) return null;
  for (const p of promos) if (promoMatchesVehicle(p, v)) return p;
  return null;
}
